export async function getAllPosts() {
  try {
    const response = await fetch('/blog-content/manifest.json')

    if (!response.ok) {
      throw new Error('Failed to load blog posts')
    }

    const posts = await response.json()
    return posts
  } catch (error) {
    console.error('Error loading blog posts:', error)
    return []
  }
}

export async function getPostBySlug(slug) {
  try {
    const response = await fetch(`/blog-content/${slug}.md`)
    const text = await response.text()

    if (text.trim().startsWith('<!DOCTYPE html>') || text.includes('<html')) {
      console.warn(
        `Post not found: ${slug} (received HTML instead of markdown)`
      )
      return null
    }
    const frontMatterPattern = /^---\s*([\s\S]*?)\s*---/
    const match = text.match(frontMatterPattern)

    if (match) {
      const frontMatter = match[1]
      const content = text.replace(frontMatterPattern, '').trim()

      const metadata = {}
      frontMatter.split('\n').forEach((line) => {
        const [key, ...valueParts] = line.split(':')
        if (key && valueParts.length) {
          metadata[key.trim()] = valueParts.join(':').trim()
        }
      })

      return {
        content,
        metadata,
      }
    }

    return {
      content: text,
      metadata: {
        title: slug,
        date: '',
        description: '',
      },
    }
  } catch (error) {
    console.error(`Error loading post ${slug}:`, error)
    return null
  }
}
